import { render } from "./Bike.vue?vue&type=template&id=8cd90578&ts=true"
import script from "./Bike.vue?vue&type=script&lang=ts"
export * from "./Bike.vue?vue&type=script&lang=ts"

import "./Bike.vue?vue&type=style&index=0&id=8cd90578&lang=scss"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__